import { Grid, Typography } from "@mui/material";
import { IconMoodEmpty } from "@tabler/icons-react";
import React from "react";

export const NoSummary = () => {
    return (
        <Grid container alignItems={"center"} justifyContent={"center"} gap={1} direction={'column'}>
            <Grid item>
                <IconMoodEmpty size={40} color="red" />
            </Grid>
            <Grid item sx={{ textAlign: 'center' }}>
                <Typography variant="h5" color={'primary'}>Data Not Available.</Typography>
                <Typography variant="h6" color={'primary'}>No results found for your search. Please try different keywords.</Typography>
            </Grid>
        </Grid>
    )
}